import { inViewport } from './elementsInViewport.js';
export const loadMore = (target) => {
    
    const loadTarget = document.querySelector(target);

    if (!loadTarget || !document.querySelector(target)) {
        return;
    }
    let loadTrigger;

    if (loadTarget.nextElementSibling) {
        loadTrigger = loadTarget.nextElementSibling;
    }
    if (!loadTrigger) {
        return;
    }

    const getNext = () => {
        const items = loadTarget.querySelectorAll('[data-next]');
        const lastItem = items.length ? items[items.length - 1] : null;

        const url = lastItem && lastItem.dataset.next;
        if (!url || url.length < 2) {
            if (loadTrigger) {
                loadTrigger.style.display = 'none';
            }
            return false;
        }
        lastItem.removeAttribute('data-next');
        return url;
    }
  
    let url = getNext();
    loadTrigger.addEventListener('click', (e) => {
        if (url) {
            fetch(url)
                .then((response) => {
                    return response.text();
                })
                .then((html) => {
                    loadTarget.insertAdjacentHTML("beforeend", html);
                    inViewport();
                    //console.log(url);
                    url = getNext();
                });
                window.animatedElements = document.querySelectorAll(
                    '._js_inViewport',
                );
        }
    });
};
